import { CheckboxIcon } from '@/_assets/icon-components';
import { Box, Flex, RadioCard } from '@chakra-ui/react';
import * as React from 'react';

interface RadioCardItemProps extends RadioCard.ItemProps {
  icon?: React.ReactElement;
  label?: React.ReactNode;
  description?: React.ReactNode;
  addon?: React.ReactNode;
  indicator?: React.ReactNode | null;
  indicatorPlacement?: 'start' | 'end' | 'inside';
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const RadioCardItem = React.forwardRef<
  HTMLInputElement,
  RadioCardItemProps
>(function RadioCardItem(props, ref) {
  const {
    children,
    inputProps,
    label,
    description,
    addon,
    icon,
    indicator = <RadioCard.ItemIndicator />,
    indicatorPlacement = 'end',
    ...rest
  } = props;

  const hasContent = label || description || icon;
  const ContentWrapper = indicator ? RadioCard.ItemContent : React.Fragment;

  return (
    <RadioCard.Item {...rest}>
      <RadioCard.ItemHiddenInput ref={ref} {...inputProps} />
      <RadioCard.ItemControl px={0} gap={4}>
        {indicatorPlacement === 'start' && indicator}
        {hasContent && (
          <ContentWrapper>
            {icon}
            {label && (
              <RadioCard.ItemText textAlign='start' lineHeight={1}>
                {label}
              </RadioCard.ItemText>
            )}
            {description && (
              <RadioCard.ItemDescription>
                {description}
              </RadioCard.ItemDescription>
            )}
            {indicatorPlacement === 'inside' && indicator}
          </ContentWrapper>
        )}
        {children}
        {indicatorPlacement === 'end' && indicator}
      </RadioCard.ItemControl>
      {addon && <RadioCard.ItemAddon>{addon}</RadioCard.ItemAddon>}
    </RadioCard.Item>
  );
});

export const RadioCardRoot = RadioCard.Root;
export const RadioCardLabel = RadioCard.Label;
export const RadioCardItemIndicator = RadioCard.ItemIndicator;

export const CustomIndicator = ({
  active,
  bg,
  w,
  h,
}: {
  active: boolean;
  bg?: string;
  w?: string | number;
  h?: string | number;
}) => {
  // Convert Chakra spacing units to pixels (1 unit = 4px)
  // So 7 units = 28px, which is the default CheckboxIcon size
  const getSizeInPx = (value: string | number | undefined): number => {
    if (!value) return 28; // Default CheckboxIcon size
    if (typeof value === 'string' && value.includes('px')) {
      return parseInt(value.replace('px', ''));
    }
    if (typeof value === 'number') {
      return value * 4; // Convert Chakra spacing to pixels
    }
    return 28;
  };

  const iconSize = getSizeInPx(w || h);
  const boxSize = w || h || 7;

  return (
    <Flex flex={1} justify='flex-end'>
      {active ? (
        <CheckboxIcon size={iconSize} color={'var(--primary-default)'} />
      ) : (
        <Box
          w={boxSize}
          h={boxSize}
          rounded='full'
          border='1px solid'
          transition='100ms ease-in-out'
          _hover={{ borderColor: 'primary' }}
          // bg={bg === 'light.300' ? '#CDCDCD' : 'light.300'}
          borderColor={'#D0D5DD'}
        />
      )}
    </Flex>
  );
};
